module.exports = __webpack_public_path__ + "static/fonts/Miller-Text.b273a055.otf";